import { render } from "./TenantAgoraConfigsManagement.vue?vue&type=template&id=014fad4e"
import script from "./TenantAgoraConfigsManagement.vue?vue&type=script&lang=js"
export * from "./TenantAgoraConfigsManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__